import $ from 'jquery';

$( document ).on('turbolinks:load', function() {
  let colors = [
    "green",
    "pink",
    "blue"
  ];
  let randomIndex = 1;

  $(".avatar-gradient").each(( index, element ) => {
    randomIndex = randomIndex > 2 ?  0 : randomIndex;
    $( element ).addClass(`avatar-gradient-${colors[randomIndex]}`);
    randomIndex++;
  });
})
